import React from 'react'

const Patient = ({ patient }) => (
    <>
        <div className="">{ patient?.name }</div>
        {
            patient?.ipNo ?
            <p className="text-gray-500 mb-0 text-xs italic">Inpatient No: { patient?.ipNo }</p>
            : patient?.tempIpNo &&
            <p className="text-gray-500 mb-0 text-xs italic">Temp Ip No: ~{ patient?.tempIpNo }~</p>
        }
        {
            patient?.matIpNo &&
            <p className="text-gray-500 mb-0 text-xs italic">Maternity No: { patient?.matIpNo }</p>
        }
        {
            patient?.opNo &&
            <p className="text-gray-500 text-xs italic">Outpatient No: { patient?.opNo < 1000 ? ('00000' + patient?.opNo).slice(-4) : patient?.opNo }</p>
        }
    </>
)

export default Patient